import { IUPPTheme } from 'interfaces';
import { PreferredDisplayMode } from '../OnboardingFormClass';

export enum HierarchyLevel {
  Merchant = 'merchant',
  Parent = 'parent',
  Grandparent = 'grandparent',
}

export type CountryCode = string;

export interface IPopupOverlayConfigDto {
  title: string;
  message: string;
}

export interface IMerchantDetailsDto {
  parentId?: string | null;
  hierarchyLevel: HierarchyLevel;
  theme?: IUPPTheme;
  country: CountryCode;
  isAllOptIn: boolean;
  redirectUrl: string;
  partnerMerchantId?: string;
  preferredDisplayMode?: PreferredDisplayMode;
  popupOverlayConfig?: IPopupOverlayConfigDto;
}

export interface IContactDetailsDto {
  financeEmail: string;
  companyNumber: string;
}

export interface IUserDetailsDto {
  userEmail: string;
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  subRoles?: string[];
}

export interface IOnboardFamilyEntityDto {
  id?: string;
  name: string;
  merchantDetails: IMerchantDetailsDto;
  contactDetails: IContactDetailsDto;
  userDetails?: IUserDetailsDto;
}